import React from "react";
import { Stack, Typography, Tooltip } from "@mui/material";
import { useTheme } from "@mui/styles";
import { ShieldStar } from "@phosphor-icons/react";

export default function ListItemSection({
  title,
  subtitle,
  isPrimary,
  onClick,
  customEditComponent,
}) {
  const { palette } = useTheme();

  const handleKeyDown = (e) => {
    if (onClick && (e.key === "Enter" || e.key === " ")) {
      e.preventDefault();
      onClick(e);
    }
  };

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      border={`1px solid ${palette.divider}`}
      padding="16px 24px"
      borderRadius="12px"
      width="100%"
      onClick={onClick ? onClick : undefined}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? handleKeyDown : undefined}
      sx={{
        cursor: onClick ? "pointer" : "default",
        "&:hover": {
          backgroundColor: onClick ? palette.action.hover : "transparent",
        },
        "&:focus-visible": {
          outline: `2px solid ${palette.primary.main}`,
          outlineOffset: "2px",
        },
      }}
    >
      <Stack>
        <Stack direction="row" alignItems="center" gap={3}>
          <Typography variant="h4">{title}</Typography>
          {isPrimary && (
            <Tooltip title="Primary insurance" placement="top">
              <ShieldStar size={20} weight="duotone" color={palette.primary.main} />
            </Tooltip>
          )}
        </Stack>
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      </Stack>
      {onClick && customEditComponent && (
        <div onClick={(e) => e.stopPropagation()}>{customEditComponent}</div>
      )}
    </Stack>
  );
}
